﻿import React, { useState } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';
import moment from 'moment';

import 'react-day-picker/lib/style.css';
import 'moment/min/locales';

//https://react-day-picker.js.org/examples/input-state
//https://momentjs.com/docs/

export const DateSelection = (props) => {
  const selectedLocale = props.locale === 'no' ? 'nb' : props.locale === 'se' ? 'sv' : props.locale;
  const currentLanguage = document.querySelector('html').getAttribute('lang');
  const currentCountry = document.querySelector('html').getAttribute('country');
  const format = currentCountry === 'no' || currentCountry === 'fi' || props.country === 'no' || props.country === 'fi' ? 'DD.MM.YYYY' : "YYYY-MM-DD";
  const title = props.title ?? '';
  moment().locale(selectedLocale)
  const startDate = moment().toDate();

  // const settings = {
  //   firstDayOfWeek: 1,
  //   month: startDate,
  //   fromMonth: startDate,
  //   modifiers: {
  //     disabled: [{
  //       before: startDate,
  //     }]
  //   }
  // };

  const settings = {
    firstDayOfWeek: 1,
    month: startDate,
  };

  if (!props.showAllDates) {
    settings.fromMonth = startDate;
    settings.modifiers = {
      disabled: [{
        before: startDate,
      }]
    }
  }

  const handleChange = (day) => {
    const dateToday = new Date();
    dateToday.setHours(12, 0, 0, 0);

    const browserLanguage = navigator.language || navigator.userLanguage;
    let pickerFormat = 'en-us';

    try {
      pickerFormat = epi.EPiServer.Forms.Samples.DateFormats[browserLanguage.toLowerCase()] ? browserLanguage : 'en-us';
    } catch (err) {
    }

    if (!day || (!props.showAllDates && day < dateToday))
      return;

    props.existingPicker.value = moment(day).locale(pickerFormat).format('L');

    if (props.onChangeEvent)
      props.onChangeEvent();
  };

  const handleTextChange = (value) => {
    props.existingPicker.value = value;
  };

  return (
    <DayPickerInput
      format={format}
      formatDate={formatDate}
      parseDate={parseDate}
      placeholder={props.placeholder}
      onDayChange={handleChange}
      value={props.existingPicker.value}
      inputProps={{placeholder: format, title, onChange: (e) => { handleTextChange(e.target.value) } }}
      dayPickerProps={{
        locale: currentLanguage,
        localeUtils: MomentLocaleUtils,
        ...settings
      }}
    />
  );
}

//{props.value.error && <div className="validation-error">{props.value.error}</div>}
